/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_ScreenInputs */

const en_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full Screen`)
};

const fr_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plein écran`)
};

const de_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollbildmodus`)
};

const it_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A schermo intero`)
};

const ru_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полноэкранный`)
};

const es_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalla completa`)
};

const zh_cn2_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏`)
};

const ja_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全画面表示`)
};

const hi_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण स्क्रीन`)
};

const pt_pt2_full_screen = /** @type {(inputs: Full_ScreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tela cheia`)
};

/**
* | output |
* | --- |
* | "Full Screen" |
*
* @param {Full_ScreenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const full_screen = /** @type {((inputs?: Full_ScreenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_ScreenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_full_screen(inputs)
	if (locale === "de") return de_full_screen(inputs)
	if (locale === "it") return it_full_screen(inputs)
	if (locale === "ru") return ru_full_screen(inputs)
	if (locale === "es") return es_full_screen(inputs)
	if (locale === "zh-CN") return zh_cn2_full_screen(inputs)
	if (locale === "ja") return ja_full_screen(inputs)
	if (locale === "hi") return hi_full_screen(inputs)
	if (locale === "pt-PT") return pt_pt2_full_screen(inputs)
	return en_full_screen(inputs)
});